import $, { trim } from "jquery";
import axios from 'axios';

let intial_load = $('.posts_f063__posts').attr('data-intial-load');
let load = $('.posts_f063__posts').attr('data-load');

$('.posts_f063__loader_button').on('click', function() {
  if(!$(this).hasClass('loading')) {
    ajax_get_posts(load);
  }
});

$('.posts_f063__filters a').on('click', function(e){
  e.preventDefault();
  $('.posts_f063__loader').css({'display': 'flex'});
  $('.posts_f063__no_more_posts_text').css({'display': 'none'});

  $('.posts_f063__filters a').removeClass('active');
  $(this).addClass('active');
  $('.posts_f063__posts').attr('data-offset', 0);
  $('.posts_f063__posts_inner').html('');
  $('.posts_f063__posts').attr('data-category', $(this).text());
  ajax_get_posts(intial_load);
});

function ajax_get_posts(l) {

  let offset = parseInt($('.posts_f063__posts').attr('data-offset'));
  let intial_load = parseInt($('.posts_f063__posts').attr('data-intial-load'));
  let load = parseInt($('.posts_f063__posts').attr('data-load'));
  let category = $('.posts_f063__posts').attr('data-category');

  let params = new URLSearchParams();
  params.append('action', 'get_posts_f063');
  params.append('load', l);
  params.append('offset', offset);
  params.append('category', category);

  $('.posts_f063__loader_button').addClass('loading');

  axios.post('/wp-admin/admin-ajax.php', params).then(res => {
    let $postsInner = $('.posts_f063__posts_inner');
    console.log(res.data);
    if (trim(res.data.data) == 'no posts') {
      $('.posts_f063__loader').css({'display': 'none'});
      $('.posts_f063__no_more_posts_text').css({'display': 'block'});
    } else {
      $postsInner.append(res.data.data);
      if(offset > 0) {
        $('.posts_f063__posts').attr('data-offset', offset + load );
      } else {
        $('.posts_f063__posts').attr('data-offset', intial_load );
      }
    }

    $('.posts_f063__loader_button').removeClass('loading');

  });
}

if($('.posts_f063__loader_button').length) {
  ajax_get_posts(intial_load);
}